import { Component, OnDestroy, OnInit } from '@angular/core';
import { FuelChangesService } from '../../../services/fuel-changes.service';
import { Subject } from 'rxjs';
import { FuelKpiRequest } from '../../../../_shared';
import { KpiFactorResponse } from '../../../../_shared/models/fuel-kpi-factor-response.model';
import { FactorTableComponent } from '../../../../_shared/components/factor-table/factor-table.component';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';

@Component({
  selector: 'app-total-fill-ups-modal',
  standalone: true,
  imports: [FactorTableComponent],
  templateUrl: './total-fill-ups-modal.component.html',
  styleUrl: './total-fill-ups-modal.component.scss'
})
export class TotalFillUpsModal implements OnInit, OnDestroy {
  request: FuelKpiRequest;
  modalFilterHeaders: any;
  formatters = {
    "Total Fill Ups": (value: number): string => value.toFixed(0),
    "Avg Fuel Per Fill Up": (value: number): string => `${value.toFixed(0)}ℓ`,
    "Total Fuel Dispensed": (value: number): string => `${value.toFixed(0)}ℓ`,
    "Fueling Frequency": (value: number): string => `${value.toFixed(2)} x/week`
  };

  factorsData: KpiFactorResponse[] = [];
  private cancelSubject: Subject<void> = new Subject<void>();

  constructor(
    private fuelChangesService: FuelChangesService,
    private errorHandlerService: ErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.getTotalFillUpsFactors();
  }

  async getTotalFillUpsFactors(): Promise<void> {
    try {
      const response = await this.fuelChangesService.getTotalFillUpsKpiFactors(this.request, this.cancelSubject);
      this.factorsData = response.data ?? [];
    } catch (error: any) {
      this.errorHandlerService.handleError(error);
    }
  }

  ngOnDestroy(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
  }
}